import { render, staticRenderFns } from "./addGf.vue?vue&type=template&id=0801ce7c&scoped=true&"
import script from "./addGf.vue?vue&type=script&lang=js&"
export * from "./addGf.vue?vue&type=script&lang=js&"
import style0 from "./addGf.vue?vue&type=style&index=0&id=0801ce7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0801ce7c",
  null
  
)

export default component.exports